import axios from 'axios';
import { get } from 'lodash';

/**
 * Returns a flattened array of field validation error messages.
 *
 * Given an error object:
 *
 *    {
 *        "errors": {
 *            "fieldName1": {
 *                "ValidationType": "error message 1"
 *            },
 *            "fieldName2": {
 *                "ValidationType": "error message 2"
 *            }
 *        }
 *    }
 *
 * This will return a flattened array of error messages:
 *
 *     ["error message 1", "error message 2"]
 *
 */
export const flattenDataErrorMessages = errors => {
    const errorsCollection = Object.values(errors);
    let messages = [];

    errorsCollection.forEach(error => {
        let keyName = Object.keys(error)[0];

        messages = [...messages, get(error, keyName, '')];
    });

    return messages;
};

export const getErrorMessage = (error) => {
    if (!error) {
        return;
    }
    // Cancelling an Axios request throws an AbortError per the fetch API. If
    // the user performed an action that cancels a request, then there is no
    // need to alert them to this error, so disregard it.
    if (axios.isCancel(error)) {
        return null;
    }
    const dataError = getDataError(error);
    if (dataError) {
        return flattenDataErrorMessages(dataError);
    }
    return getServerError(error);
};

export const getErrors = (errors) => {
    if (errors) {
        return flattenDataErrorMessages(errors);
    } else {
        return [];
    }
};


export const getDataError = (error) => {
    const errorData = get(error, 'response.data') || {};
    return errorData.errors;
};

export const getServerError = (error) => {
    const errorData = get(error, 'response.data') || {};
    const errorMetaData = get(errorData, 'meta.messages') || [];
    return errorData.error || errorMetaData.join(', ') || error.message || error;
};
